import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

import { defaultOptions as bragBarV2DefaultOptions } from '@/components/BragBarV2/register';
import { ALLOWED_CHILD_COMPONENT_NAMES } from './constants';

const LayoutSQV2 = dynamic(() => import('./LayoutSQV2'));

Builder.registerComponent(LayoutSQV2, {
	name: 'LayoutSQV2',
	friendlyName: 'Layout SQV2',
	canHaveChildren: true,
	defaultChildren: [
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'HeaderV2',
				options: {
					copy: '<p>LEGAL QUALIFICATION PORTAL</p>',
					logo: {
						'@type': '@builder.io/core:Reference',
						id: '8cb20d37a5444699a3050b4a5d527ace',
						model: 'header-logo',
					},
					logoHeight: 72,
					usePageColors: true,
					showMobileLogo: true,
					showMobileText: true,
				},
			},
		},
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'BragBarV2',
				options: {
					items: [...bragBarV2DefaultOptions.items],
					backgroundColor: bragBarV2DefaultOptions.backgroundColor,
					borderColor: bragBarV2DefaultOptions.borderColor,
					textColor: bragBarV2DefaultOptions.textColor,
					textSizeMobile: 0.75,
					textSizeDesktop: 1,
				},
			},
		},
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'CalloutBox',
				options: {
					logo: {
						'@type': '@builder.io/core:Reference',
						id: '0d7c4557c5774bddb1e2df11f9b85927',
						model: 'logo',
					},
					title: 'Privacy Guarantee',
					bodyText:
						'Your information is legally protected and will only be used to evaluate your potential claim.\n' +
						'We do not sell data to third-party marketers. All inquiries are handled with strict attorney-\n' +
						'client confidentiality standards.',
					showTitle: true,
					showBodyText: true,
					showAccent: true,
					backgroundColor: 'var(--color-light-grey)',
					accentColor: 'var(--color-dark-burgundy)',
				},
			},
		},
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'Form',
				options: {
					headingCopy: `<h2>Find Out if You Qualify</h2>
						<br/> <h3><u>SIGNIFICANT</u> Compensation May Be Available</h3>`,
				},
			},
		},
	],
	childRequirements: {
		message: `Child may be any of: ${ALLOWED_CHILD_COMPONENT_NAMES.join(', ')}`,
		query: {
			'component.name': {
				$in: [...ALLOWED_CHILD_COMPONENT_NAMES],
			},
		},
	},
	image: getIconUrl(Icon.LAYOUT),
});
